var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHeartGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.25 2.75C18.64 2.75 16.3425 3.08563 15 5.1075C13.6569 3.08563 11.36 2.75 8.75 2.75C4.60813 2.75 1.25 7.10813 1.25 11.25C1.25 18.7144 15 26.25 15 26.25C15 26.25 28.75 18.7781 28.75 11.25C28.75 7.10813 25.3919 2.75 21.25 2.75Z",
    fill: "#BBDC96"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHeartGreen);
export default __webpack_public_path__ + "static/media/icon-heart-green.81160f5ec1f632a6f26131c161134505.svg";
export { ForwardRef as ReactComponent };